export default "__VITE_ASSET__Cg07Hnbi__"